// extracted by mini-css-extract-plugin
export default {"clientsContainerAll":"Clients_clientsContainerAll__x381n","carouselDiv":"Clients_carouselDiv__OIKWm","logoCliente":"Clients_logoCliente__KuQRa"};